
import AboutMenu from '@/components/AboutMenu'

export default {
  name: 'Login',
  components: { AboutMenu },
}
